// extracted by mini-css-extract-plugin
export default {"root_bottom":"HlsNqrJdoq","commentBoxContainer":"ZXLaAhVjyJ","shadowContainer":"jclNOD3uu_"};